import {GameStateEnums} from '../../../../../../shared/GameEnums'
import {UIGameManager} from '../../UIGameManager'
import {UIHoverActionController} from '../../ui_game_hover_actions/UIHoverActionController'
import {UIGameMechanic} from '../../UIGameEventController'
import {UIGameMapTileEdgeHoverController} from './UIGameMapTileEdgeHoverController'
import {UIGameMapTileCornerHoverController} from './UIGameMapTileCornerHoverController'
import {ActionState, TurnState} from '@colonist/game-states'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums

export interface MapHoverController {
    registerHoverAction(hoverAction: UIHoverActionController): void
    onHoverStateChange(isHoverStateActive: boolean): void
    onHoverHighlightClick(): void
    onHoverHighlightCancellation(): void
}

export class UIGameMapHoverController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private isHoverStateActive: boolean
    private readonly tileEdgeHoverController: UIGameMapTileEdgeHoverController
    private readonly tileCornerHoverController: UIGameMapTileCornerHoverController

    constructor(uiGameManager: UIGameManager, shouldHighlightOnlyOnHover: boolean) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.isHoverStateActive = false
        this.tileEdgeHoverController = new UIGameMapTileEdgeHoverController(uiGameManager, shouldHighlightOnlyOnHover)
        this.tileCornerHoverController = new UIGameMapTileCornerHoverController(uiGameManager, shouldHighlightOnlyOnHover)
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.GameStateUpdated:
            case UIGameEventEnums.DiceStateUpdated:
            case UIGameEventEnums.BeginnerModeActionUpdated:
            case UIGameEventEnums.FinishedBuildingGame:
            case UIGameEventEnums.PlayerControllerStateUpdated:
            case UIGameEventEnums.BeginnerModeInteractWithGuide:
                this.updateHoverState(); break
            default: break
        }
    }

    onHoverHighlightClick() {
        this.tileEdgeHoverController.onHoverHighlightClick()
        this.tileCornerHoverController.onHoverHighlightClick()
    }

    onHoverHighlightCancellation() {
        this.tileEdgeHoverController.onHoverHighlightCancellation()
        this.tileCornerHoverController.onHoverHighlightCancellation()
    }

    onHoverStateChange() {
        this.tileEdgeHoverController.onHoverStateChange(this.isHoverStateActive)
        this.tileCornerHoverController.onHoverStateChange(this.isHoverStateActive)
    }

    private updateHoverState() {
        const updatedHoverState = this.isHoverStateUpdated()
        if(updatedHoverState == this.isHoverStateActive) return
        this.isHoverStateActive = updatedHoverState
    }

    private isHoverStateUpdated(): boolean {
        const validActionStates = [ActionState.None]
        if(!this.uiGameManager.gameController.isMyTurn) return false
        if(this.uiGameManager.gameController.diceState.diceThrown == false) return false
        if(this.uiGameManager.gameController.currentState.turnState == TurnState.GameEnd) return false
        if(!validActionStates.includes(this.uiGameManager.gameController.currentState.actionState)) return false

        return true
    }

    registerTileEdgeHoverAction(hoverAction: UIHoverActionController) {
        this.tileEdgeHoverController.registerHoverAction(hoverAction)
    }

    registerTileCornerHoverAction(hoverAction: UIHoverActionController) {
        this.tileCornerHoverController.registerHoverAction(hoverAction)
    }
}
